module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plain-banner"
  }, [_c('svg-icon', {
    staticClass: "plain-banner__icon plain-banner__icon--smaller icon icon--white",
    attrs: {
      "icon": "sleeping-webkey"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__container"
  }, [_c('v-layout', {
    staticClass: "plain-banner__description",
    attrs: {
      "justify-space-between": "",
      "column": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("Please check the following steps to go online again:")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("• Device is turned on")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row--wbreak"
  }, [_vm._v("• Device is connected to the internet or wifi")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("• Webkey Client App is installed on the device")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row"
  }, [_vm._v("• You are logged in to your Webkey account")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__row--wbreak"
  }, [_vm._v("• Toggle shows “ON” in Webkey Client App")]), _vm._v(" "), _c('div', {
    staticClass: "plain-banner__footer"
  }, [_c('span', {
    staticClass: "plain-banner__footer--text"
  }, [_vm._v("We will automatically try connecting in " + _vm._s(_vm.retryTimer) + " seconds…")]), _vm._v(" "), _c('a', {
    staticClass: "link--white",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Retry now")])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "plain-banner__title title--general title--1"
  }, [_vm._v("Device is "), _c('b', {
    staticClass: "badge badge--smaller badge--offline badge--inline"
  }), _vm._v("offline")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7160c860","hasScoped":false}!./app/components/device-offline/template.html
// module id = 391
// module chunks = 0